import React, { useState } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import useAuth from "@/components/common/header/useAuth";
import { VscCopy } from "react-icons/vsc";
import PopupSignInUp from "@/components//common/PopupSignInUp";
import LoginModal from "@/components/common/user-credentials/LoginModal";
import { useDispatch, useSelector } from "react-redux";

import { isValidSession } from "@/api/auth";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import _, { isEmpty } from 'lodash';
import NDAModel from "../../../components/pdp/BidCenter/NDAModel.jsx";
import { downloadCommercialDocument } from '@/api/PDP';
import { trackButtonClick } from "@/utils/analytics.js";



const DocumentSectionCommercial = ({
  pdpDocuments,
  propertyDocumentsInformation,
  address,
  isNDASigned
}) => {
  const { streetNumber, streetName, city, state, zip } = address;
  const fullAddress = `${streetNumber} ${streetName}, ${city}, ${state} ${zip}`;
  const { propertyDocumentMap, otherDocumentList } =
    propertyDocumentsInformation;
  const { isUserLoggedIn, userName, userSignOut } = useAuth();
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const user_info = useSelector((state) => state?.user?.user);
  const [showNDA, setShowNDA] = useState(false);

    const ndaCommercialAccepted = useSelector((state) => state.pdp.isNDAAccepted);

  // const ndaCommercialAccepted = pdpInitData?.ndaCommercialAccepted;

  console.log('ndaCommercialAccepted', ndaCommercialAccepted)

  const profileInfo = useSelector((state) => state.user.user);


  const dispatch = useDispatch();

  const handleSignIn = async () => {

    // const isValid = isSessionValid.data?.isValidSession;
    if (isUserLoggedIn) {
      if (ndaCommercialAccepted === 'Y') {
        //Show Document

      } else {
        setShowNDA(true);
        trackButtonClick({
          eventName: "document_section_unlock_click",
          eventCategory: "NEW-PDP",
          eventSource: "on view important documents click",
          eventLabel: `PropertyId: ${pdpInitData?.propertyDetails?.propertyId}`
        })
      }

    }
    else {
      dispatch(setLoginModal(true));
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("Popup"));

      trackButtonClick({
        eventName: "document_section_signin_click",
        eventCategory: "NEW-PDP",
        eventSource: "on view important documents click",
        eventLabel: `PropertyId: ${pdpInitData?.propertyDetails?.propertyId}`
      })
    }

  }

  const getDocCTA = () => {
    if (!user_info || user_info === null || isEmpty(user_info)) {
      return "  REGISTER TO VIEW IMPORTANT DOCUMENTS"
    }
    else if (ndaCommercialAccepted !== 'Y') {

      return "  CLICK TO UNLOCK THE DOCUMENTS"
    }

  }

  const getImage = () => {
    if (!user_info || user_info === null || isEmpty(user_info)) {
      return "/assets/images/document.png"
    }
    else if (ndaCommercialAccepted !== 'Y') {

      return "/assets/images/Lock.png"
    }
  }

  const handleNDAccepted = () => {
    setShowNDA(false);


  }

  const handleNDAClose = () => {
    setShowNDA(false);
  }

  const handleCommericalDoc = async (item) => {

    await downloadCommercialDocument(propertyDocumentMap[item]);

  }



  return (


    <div className="propertyInfoBox mb30 tour-pdp-details mobile-margin-0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' tabIndex="0" >
          Documents
        </h3>

      </Row>

      {
        (isUserLoggedIn && ndaCommercialAccepted === 'Y') ?
          <div className="container">
            <div className="row">

              <div>
                <p className='disclaimerText pt25 pl20 pr25' tabIndex="0">{`${pdpDocuments?.description} ${fullAddress}`}</p>
                {/* </div> */}

                <div className="documentGrid pb30 pt20">
                  {Object.keys(propertyDocumentMap).map((item, index) => {
                    if (
                      propertyDocumentMap[[item]]?.documentUrl === undefined ||
                      propertyDocumentMap[[item]]?.documentUrl === null ||
                      propertyDocumentMap[item]['fileListId'] === null
                    ) {
                      return null;
                    }
                    return (

                      <div className="documentItem pt20" key={`property-${index}`}>
                        <a
                          className="flaticon-pdf hubzu-text-thm pr10  documentText"
                          style={{ textDecoration: "underline !important" }}
                          onClick={() => handleCommericalDoc(item)}

                          target="_blank"
                        >
                          {/* {" "} */}
                          <span className="pl10"> {propertyDocumentMap[[item]].documentName}</span>
                          {/* {propertyDocumentMap[[item]].documentName} */}

                        </a>
                      </div>

                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          :
          <div className="container">
            <div className="row">

              <div>
                <p className='disclaimerText pt25 pl20 pr25' tabIndex="0">{`Click below to register and view available documents for ${fullAddress}`}</p>
                {/* </div> */}


                <div className="docRegisterBtn">
                  <button className="impDocBtn"
                    onClick={() => handleSignIn()}>

                    <img

                      width={28}
                      height={28}
                      src={getImage()}
                      alt="bh1.jpg"
                    />
                   <span className="pl5">{getDocCTA()}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

      }
      <NDAModel
        show={showNDA}
        isFormDocuments={true}
        handleClose={handleNDAClose}
        handleNDAccept={handleNDAccepted}
        userProfileData={profileInfo} />
    </div>

  );
};

export default DocumentSectionCommercial;
